// material-ui
import { createTheme } from "@mui/material/styles";

// third-party
import { presetPalettes } from "@ant-design/colors";

// project import
import ThemeOption from "./theme";

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (mode) => {
  const colors = presetPalettes;

  const greyPrimary = [
    "#ffffff",
    "#fafafa",
    "#f5f5f5",
    "#f0f0f0",
    "#d9d9d9",
    "#bfbfbf",
    "#8c8c8c",
    "#595959",
    "#262626",
    "#141414",
    "#000000",
  ];
  const greyAscent = ["#fafafa", "#bfbfbf", "#434343", "#1f1f1f"];
  const greyConstant = ["#fafafb", "#e6ebf1"];

  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor = ThemeOption(colors);

  return createTheme({
    palette: {
      mode,
      common: {
        black: "#000",
        white: "#fff",
      },
      ...paletteColor,
      text: {
        main: mode === "dark" ? "#fff" : paletteColor.primary.main,
        primary: mode === "dark" ? "#fff" : paletteColor.primary.main,
        secondary: paletteColor.grey[500],
        disabled: paletteColor.grey[400],
        dark: "#0c142c",
      },
      border: {
        // main: paletteColor.grey[300],
        main: "#f0f0f0",
        mui: "#eee",
        light: paletteColor.grey[200],
        secondary: paletteColor.grey[500],
        contrastText: paletteColor.grey[0],
      },
      action: {
        disabled: paletteColor.grey[300],
      },
      divider: paletteColor.grey[200],
      background: {
        paper: "--var(--background-paper)",
        default: mode === "dark" ? "#353535" : paletteColor.grey[0],
      },
      gradient: {
        primary:
          mode === "dark"
            ? "linear-gradient(45deg, #0C142C 30%, #00B1E7 90%)"
            : "linear-gradient(45deg, #0C142C 30%, #00B1E7 90%)",
        secondary:
          mode === "dark"
            ? "linear-gradient(45deg, #0C142C 30%, #0C142C 90%)"
            : "linear-gradient(193deg, rgba(255, 255, 255, 0.68) 20.85%, #EFF2FF 55.76%)",
      },
      components: {
        MuiCssBaseline: {
          styleOverrides: {
            ":root": {
              "--color-primary": mode === "dark" ? "#EFF2FF" : "#0C142C",
              "--color-primary-light": mode === "dark" ? "#0C142C" : "#EFF2FF",
              "--color-primary-muted": "#718096",
              "--color-secondary-dark": "#F76B1C",
              "--color-secondary-dark-muted": "#718096",
              "--color-text-dark": "0C142C",
              "--color-secondary": "#F76B1C",
              "--color-text-dark": "0C142C",
              "--color-text-dark-muted": "#718096",
            },
            body: {
              transition: "background-color 0.3s ease",
              backgroundColor: mode === "dark" ? "#121212" : "#ffffff",
            },
          },
        },
      },
    },
  });
};

export default Palette;
